<div class="wrapper">
  @if (!headless()) {
  <mat-toolbar class="toolbar">
    <mat-toolbar-row>
      @if (isDevelopmentMode) {
      <button mat-icon-button
              (click)="sidenav.toggle()"
              style="color: white;">
        <mat-icon>menu</mat-icon>
      </button>
      }
      <div class="branding-link"
           [routerLink]="redirectToHomeAllowed() ? './' : undefined">
        <img class="branding-image"
             [src]="mobileQuery.matches ? 'assets/img/logo-super-small.png' : 'assets/img/logo.png'"
             alt="logo" />
      </div>
      @if (isDevelopmentMode) {
      <div class="dev-text">DEV</div>
      }
      @if (isDevelopmentMode) {
      <div class="languageListContainer">
        <ul class="languageList">
          <li [ngClass]="currentLanguage() === 'de' ? 'selected': 'unselected'"><a
               (click)="useLanguage('de')">DE</a></li><span class="spanSpacer"></span>
          <li [ngClass]="currentLanguage() === 'en' ? 'selected': 'unselected'"><a
               (click)="useLanguage('en')">EN</a></li><span class="spanSpacer"></span>
        </ul>
      </div>
      }
      <span class="menu-spacer"></span>
      @if (showLoginArea()) {
      <div id="auth-wrapper">
        @if (isAdmin && isAuthenticated()) {
        <button class="angled-btn"
                mat-stroked-button
                routerLink="/customer-overview">
          <mat-icon id="angled-button-icon">admin_panel_settings</mat-icon>
        </button>
        }
        @if (isAuthenticated() === false) {
        <button class="angled-btn"
                mat-stroked-button
                (click)="login()">
          <div id="login-label">
            {{ 'login' | translate }}
          </div>
        </button>
        }
        <mat-menu #loginMenu="matMenu"
                  id="login-menu">
          <div class="account-info">
            <mat-icon class="account-icon">account_circle</mat-icon>
            <div class="account-description">
              <span>{{userProfileData()?.givenName}} {{userProfileData()?.familyName}}</span>
              <span>{{userProfileData()?.email}}</span>
            </div>
          </div>
          <mat-divider></mat-divider>
          <button mat-menu-item
                  (click)="editUserProfile()">
            <mat-icon>edit</mat-icon>
            <span>{{ 'editUserProfile' | translate }}</span>
          </button>
          <button mat-menu-item
                  (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>{{ 'logout' | translate }}</span>
          </button>
        </mat-menu>
        @if (isAuthenticated()) {
        <button class="angled-btn"
                mat-stroked-button
                [matMenuTriggerFor]="loginMenu">
          <mat-icon id="angled-button-icon">account_circle</mat-icon>
        </button>
        }
        @if (redirectToHomeAllowed()) {
        <button class="angled-btn"
                mat-stroked-button
                routerLink="./">
          <mat-icon id="angled-button-icon">home</mat-icon>
        </button>
        }
      </div>
      }
    </mat-toolbar-row>
  </mat-toolbar>
  }
  <mat-sidenav-container class="content">
    <mat-sidenav #sidenav
                 fxShow="true"
                 mode="over">
      <mat-nav-list>
        <a routerLink="./"
           mat-list-item
           (click)="sidenav.toggle()">
          <mat-icon matListItemIcon>home</mat-icon>
          <span matListItemTitle>{{ 'landingPage' | translate }}</span>
        </a>
        <a routerLink="/app-download"
           mat-list-item
           (click)="sidenav.toggle()">
          <mat-icon matListItemIcon>download</mat-icon>
          <span matListItemTitle>{{ 'appDownload' | translate }}</span>
        </a>
        <a routerLink="/app-feature-highlights"
           mat-list-item
           (click)="sidenav.toggle()">
          <mat-icon matListItemIcon>new_releases</mat-icon>
          <span matListItemTitle>{{ 'featureHighlights' | translate }}</span>
        </a>
        <a routerLink="/docuconversion"
           mat-list-item
           (click)="sidenav.toggle()">
          <mat-icon matListItemIcon>swap_horiz</mat-icon>
          <span matListItemTitle>{{ 'docuConversation' | translate }}</span>
        </a>
        <a routerLink="/crossReferenceSearch"
           mat-list-item
           (click)="sidenav.toggle()">
          <mat-icon matListItemIcon>search</mat-icon>
          <span matListItemTitle>{{ 'crossReferenceSearch' | translate }}</span>
        </a>
          @if (isDevelopmentMode) {
        <a routerLink="/nc-aggregate-lubrication"
           mat-list-item
           (click)="sidenav.toggle()">
          <mat-icon matListItemIcon>smart_display</mat-icon>
          <span matListItemTitle>{{ 'ncAggregateLubricationMenu' | translate }}</span>
        </a>
          }
        <a routerLink="/release-note-history"
           mat-list-item
           (click)="sidenav.toggle()">
          <mat-icon matListItemIcon>history</mat-icon>
          <span matListItemTitle>{{ 'releaseNotes' | translate }}</span>
        </a>
        <a routerLink="/software-vulnerability"
           mat-list-item
           (click)="sidenav.toggle()">
          <mat-icon matListItemIcon>report_problem</mat-icon>
          <span matListItemTitle>{{ 'securityVulnerabilities' | translate }}</span>
        </a>
        <a routerLink="/user-management-overview"
           mat-list-item
           (click)="sidenav.toggle()">
          <mat-icon matListItemIcon>account_circle</mat-icon>
          <span matListItemTitle>{{ 'userManagement' | translate }}</span>
        </a>
        <a routerLink="/start-digital-app"
           mat-list-item
           (click)="sidenav.toggle()">
          <mat-icon matListItemIcon>open_in_new</mat-icon>
          <span matListItemTitle>{{ 'digitalAppStart' | translate }}</span>
        </a>
      </mat-nav-list>
    </mat-sidenav>
    <div #main
         style="height: 100%;">
      <router-outlet></router-outlet>
    </div>

  </mat-sidenav-container>
  @if (!headless()) {
  <footer class="text-center">
    <article>
      <nav id="footer-nav">
        <div id="link-wrapper">
          <a routerLink="{{ 'imprintRoute' | translate }}">{{ 'imprint' | translate }}</a>
          <span>&nbsp;|&nbsp;</span>
          <a routerLink="{{ 'privacyRoute' | translate }}">{{ 'dataProtection' | translate }}</a>
        </div>
      </nav>
    </article>
    <mat-slide-toggle class="icon-slide-toggle"
                      [ngModel]="isDarkMode()"
                      (ngModelChange)="isDarkMode.set($event)"
                      (change)="toggleTheme()">
    </mat-slide-toggle>
  </footer>
  }
</div>